export default "__VITE_ASSET__cad8b1c4__"